








import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import AsiCard from "@/components/common/AsiCard.vue";
import {Icon} from "@/helpers/icons";
import User from "@/models/user/User";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import {Permissions, Roles} from "@/helpers/constants";

@Component({
	components: {AsiContentContainer, AsiCard}
})
export default class UserCardRightsCustomer extends Vue {

	@Prop({type: Object, default: null})
	public user!: User | null;

	@Prop({type: Array, required: true})
	public roles!: Roles[];

	@Prop({type: Array, required: true})
	public permissions!: Permissions[];

	private get icon(): string {
		return this.hasRole ? Icon.yes : Icon.no;
	}

	private get iconBgColor(): string {
		return this.hasRole ? 'success' : 'error';
	}

	private get hasRole(): boolean {
		return this.roles.includes(Roles.roleCustomer);
	}

}
